import { useState } from "react";
import { faqs } from "@/mocks/homeData";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="lg:col-span-1">
            <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
              FAQ
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              关于免费范围、资源更新与使用方式的常见疑问，先在这里看看，多半能找到答案。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              点击任意问题即可展开或收起详细说明。
            </p>
          </div>

          <div className="lg:col-span-2 flex flex-col gap-3">
            {faqs.map((f, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={f.q}
                  className={`rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-start gap-3">
                      <span className="font-heading text-sm font-bold text-primary-600 mt-0.5">
                        Q{idx + 1}
                      </span>
                      <span className="font-heading text-sm md:text-base font-bold text-foreground-950">
                        {f.q}
                      </span>
                    </span>
                    <i
                      className={`${isOpen ? "ri-subtract-line" : "ri-add-line"} text-lg text-foreground-500 shrink-0`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                    }`}
                  >
                    <p className="px-5 pb-5 pl-11 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}